import { defineMessages } from "react-intl";

const messages = defineMessages({
    a1_h3: {
        id: "choir.landing.features.a1.h3",
    },
    a2_h3: {
        id: "choir.landing.features.a2.h3",
    },
    a3_h3: {
        id: "choir.landing.features.a3.h3",
    },
    a1_d: {
        id: "choir.landing.features.a1.d",
    },
    a2_d: {
        id: "choir.landing.features.a2.d",
        defaultMessage: "Lorem ipsum dolor"
    },
    a3_d: {
        id: "choir.landing.features.a3.d",
    },
    a3_s: {
        id: "choir.landing.features.a3.s",
    },
    join: {
        id: "choir.landing.features.join",
    },
    start: {
        id: "landing.start",
    },
});

export default messages;
